<app-modal [open]="open"
           [title]="'Anexos - ' + entityName"
           [width]="720"
           [height]="520"
           (close)="close.emit()">

  <div modalBody class="attachments-modal">
    <!-- Área de Upload -->
    <div class="upload-area">
      <input #fileInput type="file"
             accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
             (change)="onFileSelected($event)"
             style="display:none">
      <button class="btn btn--yellow"
              (click)="fileInput.click()"
              [disabled]="uploading">
        <i class="fas fa-cloud-upload-alt"></i>
        <span>{{ uploading ? 'Enviando...' : 'Adicionar Anexo' }}</span>
      </button>
      <small>PDF, DOC, DOCX, JPG, PNG, GIF • Max 10 MB</small>
    </div>

    <!-- Lista de Anexos -->
    <div class="attachments-list" *ngIf="!loading">
      <div class="attachment-item" *ngFor="let att of attachments">
        <div class="attachment-info">
          <i [class]="getFileIcon(att.type)"></i>
          <div class="attachment-details">
            <span class="attachment-name">{{ att.name }}</span>
            <span class="attachment-meta">{{ formatSize(att.size) }} • {{ formatDate(att.uploadedAt) }}</span>
          </div>
        </div>
        <div class="attachment-actions">
          <button class="btn-icon" (click)="downloadAttachment(att)" title="Baixar">
            <i class="fas fa-download"></i>
          </button>
          <button class="btn-icon delete" (click)="deleteAttachment(att)" title="Excluir">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>

      <div class="empty-state" *ngIf="attachments.length === 0">
        <i class="fas fa-paperclip"></i>
        <p>Nenhum anexo adicionado ainda</p>
        <small>Adicione documentos, fotos e arquivos relacionados</small>
      </div>
    </div>

    <div class="loader-state" *ngIf="loading">
      <app-loader></app-loader>
    </div>
  </div>

  <div modalFooter>
    <button class="btn btn--ghost" (click)="close.emit()">
      Fechar
    </button>
  </div>
</app-modal>
